import { ISummaryServices } from './summary.types';
import { Summary, ISummaryData } from '@/entities';
import { Utilities as utils} from '@/shared/utilities'
import { ChangeMyColor } from '@/shared/directive/color-directive';
import { http } from '@/shared/https';

export class SummaryServices implements ISummaryServices {
    
    /** get the technical appl summary */
    getTechnicalApplicationSummary(template: any, data: any): Summary {

        let appSummary: Summary = new Summary( {} as ISummaryData);

        for(const key in template.properties) {
            const prop = template.properties[key];
            appSummary = utils.calculateSummary(prop, data, appSummary);
        }        

        return appSummary;

    }

    /** get the logframework summary */
    getLogFrameSummary(template: any, data: any): Summary {

        let appSummary: Summary = new Summary( {} as ISummaryData);

        // check the logframework is filled.
        if(data && data.logframework) {
            if(data.logframework.length > 0) {
                data.logframework.forEach((result: any) => {
                    appSummary.propsCount += 1;
                    if(result.deliverables && result.deliverables.length > 0) {
                        appSummary.filledProps += 1;
                        result.deliverables.forEach((deliverable: any) =>  {
                            appSummary.propsCount += 1;
                            if(deliverable.activities &&  deliverable.activities.length > 0) {
                                appSummary.filledProps += 1;
                            }                            
                        })
                    }
                })
            }
        }

        /** monitoring plan */
        if(data && data.monitoringPlan && data.monitoringPlan.indicators) {
            Object.keys(data.monitoringPlan.indicators).forEach((plan: any) => {
                appSummary.propsCount += 1;
                if(data.monitoringPlan.indicators[plan] 
                    && data.monitoringPlan.indicators[plan].length > 0) {
                    appSummary.filledProps += 1;
                }
            });
            if(data.monitoringPlan.data)
                this.monitoringPlanSummary(data.monitoringPlan.data, appSummary);
        }

        return appSummary;
    }

    /** get the checklist summary */
    getSubmitSummary(template: any, data: any): Summary {        
        let appSummary: Summary = new Summary({} as ISummaryData);
        if (template) {
            // const { mandatoryDocs } = template;
            Object.keys(template).forEach((cKey) => {
                if (template[cKey]['x-display'] == 'checklist') {

                    const mandatoryDocs = template[cKey];
                    if (mandatoryDocs) {
                        Object.keys(mandatoryDocs.properties).forEach((docKey) => {
                            const doc = mandatoryDocs.properties[docKey];
                            if (doc.type === 'boolean') {
                                appSummary.propsCount += 1;
                                const docProp = doc['x-doc-key'];
                                if (!utils.isEmpty(data[docProp])) {
                                    appSummary.filledProps += 1;
                                }
                            } else if (doc.type === 'array') {
                                const docProp = doc['x-doc-key'];
                                const propPaths = docProp.replace('[]', '').split('.');

                                if (propPaths.length === 2) {
                                    const arrVal = data[propPaths[0]];
                                    appSummary.propsCount += 1;
                                    if (arrVal && arrVal.length > 0) {
                                        let docMissing = false;
                                        arrVal.forEach((val) => {
                                            if (utils.isEmpty(val[propPaths[1]])) {
                                                docMissing = true;
                                            }
                                        });
                                        if (!docMissing) {
                                            appSummary.filledProps += 1;
                                        }
                                    }
                                }
                            } else if (doc.type === 'object') {
                                Object.keys(doc.properties).forEach((childDocKey) => {
                                    const childDoc = doc.properties[childDocKey];
                                    if (childDoc.type == 'array') {
                                        const newChildDocProps = childDoc['x-doc-key'];
                                        const propPath = newChildDocProps.replace('[]', '').split('.');
                                        const arrValue = data[propPath[0]];
                                        let docData = false;
                                        if (arrValue && arrValue.length > 0) {
                                            arrValue.forEach((val) => {
                                                if (!utils.isEmpty(val[propPath[1]])) {
                                                    docData = true;
                                                }
                                            });
                                            if (docData) {
                                                appSummary.filledProps += 1;
                                            }
                                        }
                                    }
                                    appSummary.propsCount += 1;
                                    const childDocProp = childDoc['x-doc-key'];
                                    if (!utils.isEmpty(data[childDocProp])) {
                                        appSummary.filledProps += 1;
                                    }
                                })
                            }
                        })
                    }
                }
            });
        }
        return appSummary;
    }

    /** get the series properties summary */
    getSeriesProperties(lineItem: any, props: any, series: any, appSummary: Summary) {
        series.forEach((objSeries) => {
            Object.keys(props).forEach((key) => {
                const seriesProp = props[key];
                if(seriesProp['x-display'] !== 'hidden') {
                    appSummary.propsCount += 1;
                    if(lineItem && lineItem[objSeries.name] && ![undefined, null].includes(lineItem[objSeries.name][key]))
                        appSummary.filledProps += 1;
                }
            })
        })
    }

    /** get summary of the line item */
    getBudgetCategoryummary(lineItems: any, props: any, series: any, appSummary: Summary) {
        lineItems.forEach((line) => {
            Object.keys(props).forEach((key) => {
                const prop = props[key];
                if(!prop.readonly && prop['x-display'] !== 'hidden') {
                    if(prop['x-display'] === 'series') {
                        if(prop.items && prop.items.properties) {
                            this.getSeriesProperties(line, prop.items.properties, series, appSummary )
                        }
                    } else {
                        appSummary.propsCount += 1;
                        if(line && ![undefined, null].includes(line[key])) {
                            appSummary.filledProps += 1;
                        }
                    }
                }                    
            })
        })
    }

    /** get the technical appl summary */
    getBudgetSummary(template: any, data: any): Summary {

        let appSummary: Summary = new Summary( {} as ISummaryData);

        // get the schema properties
        const categories = utils.getNestedValue(template, 'properties.categories.default');
        const lineItemProps = utils.getNestedValue(template, 'properties.data.items.properties');

        if(data && data.applicationBudget) {
            const budgetData = data.applicationBudget.data;
            const series = data.applicationBudget.series;

            if(categories && budgetData) {
                categories.forEach((category) => {
                    appSummary.propsCount += 2;
                    if(budgetData[category.id] && budgetData[category.id].length > 0) {
                        appSummary.filledProps += 2;
                        this.getBudgetCategoryummary(budgetData[category.id], lineItemProps, series, appSummary);
                    }
                })
            }
        }
        
        return appSummary;

    }

    /** get the technical appl summary */
    getDueDeligenceSummary(template: any, data: any): Summary {

        let appSummary: Summary = new Summary( {} as ISummaryData);

        for(const key in template.properties) {
            const prop = template.properties[key];
            appSummary = utils.calculateSummary(prop, data, appSummary);
        }  

        return appSummary;
    }

    /** get safeguard summary */
    getSafeguardSummary(template: any, data: any): Summary {

        let appSummary: Summary = new Summary( {} as ISummaryData);

        appSummary = utils.calculateSummary(template, data, appSummary);

        return appSummary;

    } 


    /** recurive function to get the pmp summary */
    monitoringPlanSummary(data: any, summary: Summary ) {
        if(data) {
            if(Object.keys(data).includes('target')) {
                summary.propsCount += 2;
                if(![ undefined, null, '' ].includes(data.target)) {
                    summary.filledProps += 1;
                }
                if(![ undefined, null, '' ].includes(data.baseline)) {
                    summary.filledProps += 1;
                }
            } else {
                Object.keys(data).forEach((key) => {
                    this.monitoringPlanSummary(data[key], summary);
                })
            }
        }
    }

    /** get the negotiation log */
    getNegotiationLog(id: number) {
        return http.get(`/api/Application/${id}/NegotiationLog`,)
        .then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            }
        });
    }
    getGrantsNegotiationLog(id: number)
    {
        return http.get(`/api/Grant/GetNegotiationlog/${id}`,)
        .then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            }
        });
    }

    /** get the negotiation log */
    validateForm(id: number, data: any) {
        return http.post(`/api/Application/validate/${id}`,data)
        .then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            }
        });
    }
}